import React from "react";
import Sidebar from "../../common/components/Sidebar/sidebar";

import AgentManagementCom from "../../common/components/agentManagement/AgentManagementCom";

const AgentManagement = () => {
  return (
    <>
      <section className="agent_management_main_section">
        <div className="container-fluid">
          <div className="row p-0">
            <div className="col-lg-2 p-0 m-0">
              <Sidebar />
            </div>
            <div className="col-lg-10 p-0 m-0">
              <AgentManagementCom />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AgentManagement;
